<template>
  <FinancialValidationView
    @change="handleFinancialValidationChange"
    @skipValidation="skipSaveValidation = $event"
  />
</template>

<script>
import _ from 'lodash'

import FinancialValidationView from './FinancialValidationView.vue'

export default {
  name: 'ValidationView',

  components: {
    FinancialValidationView,
  },

  data() {
    return {
      originalValidatedReview: {},
      newValidatedReview: {},
      skipSaveValidation: false,
    }
  },

  beforeRouteLeave(to, from, next) {
    const isValidatedReviewEqual = _.isEqual(
      this.originalValidatedReview,
      this.newValidatedReview
    )
    if (isValidatedReviewEqual || this.skipSaveValidation) return next()
    if (window.confirm(this.$t('rev.validation.unsaved_validation'))) {
      next()
    } else {
      next(false)
    }
  },

  methods: {
    handleFinancialValidationChange(event) {
      const {
        originalValidatedReview = this.originalValidatedReview,
        newValidatedReview = this.newValidatedReview,
      } = event
      this.originalValidatedReview = originalValidatedReview
      this.newValidatedReview = newValidatedReview
    },
  },
}
</script>
